import { createAsyncThunk } from "@reduxjs/toolkit";
import { tournamentsRepository } from "api/tournamentsRepository";
import { validationSearchUserName } from "common/helpers/validators/validationSearchUserName";
import { ThunkApiType } from "common/interfaces/common";
import {
  PlayOffStage,
  SavingPlayOffStage,
  Tournament,
  TournamentFilter,
  TournamentsResponse,
  TournamentTable,
} from "common/interfaces/tournaments";
import { getTournaments } from "store/dictionary/dictionaryActionAsync";

export const getTournamentsByFilter = createAsyncThunk<TournamentsResponse, TournamentFilter, ThunkApiType>(
  "tournament/byFilter",
  async (filters, { rejectWithValue }) => {
    validationSearchUserName(filters.FullName);

    return await tournamentsRepository.fetchByFilter(filters).catch((error) => rejectWithValue({ error }));
  }
);

export const getTournamentById = createAsyncThunk<Tournament, Tournament["Id"], ThunkApiType>(
  "tournament/byId",
  async (id, { rejectWithValue }) => {
    return await tournamentsRepository.fetchById(id).catch((error) => rejectWithValue({ error }));
  }
);

export const publishTournaments = createAsyncThunk<Tournament, Tournament, ThunkApiType>(
  "tournament/publish",
  async (stadium, { rejectWithValue, dispatch }) => {
    return await tournamentsRepository
      .publish(stadium)
      .then((res) => {
        dispatch(getTournaments());

        return res;
      })
      .catch((error) => rejectWithValue({ error }));
  }
);

export const draftTournaments = createAsyncThunk<Tournament, Tournament, ThunkApiType>(
  "tournament/draft",
  (stadium, { rejectWithValue, dispatch }) =>
    tournamentsRepository
      .draft(stadium)
      .then((res) => {
        dispatch(getTournaments());

        return res;
      })
      .catch((error) => rejectWithValue({ error }))
);

export const getTournamentTable = createAsyncThunk<
  TournamentTable,
  { tournamentId: Tournament["Id"]; seasonId: string },
  ThunkApiType
>(
  "tournament/getTable",
  async ({ tournamentId, seasonId }: { tournamentId: Tournament["Id"]; seasonId: string }, { rejectWithValue }) =>
    await tournamentsRepository.fetchTable(tournamentId, seasonId).catch((error) => rejectWithValue({ error }))
);

export const saveTournamentTable = createAsyncThunk<TournamentTable, TournamentTable, ThunkApiType>(
  "tournament/saveTable",
  async (table, { rejectWithValue }) =>
    await tournamentsRepository.saveTable(table).catch((error) => rejectWithValue({ error }))
);

export const getTournamentPlayOffStages = createAsyncThunk<
  PlayOffStage[],
  { tournamentId: Tournament["Id"]; seasonId: string },
  ThunkApiType
>(
  "tournament/savePlayOffStage",
  async ({ tournamentId, seasonId }, { rejectWithValue }) =>
    await tournamentsRepository.getPlayOffStages(tournamentId, seasonId).catch((error) => rejectWithValue({ error }))
);
export const saveTournamentPlayOffStage = createAsyncThunk<SavingPlayOffStage, SavingPlayOffStage, ThunkApiType>(
  "tournament/savePlayOffStage",
  async (stage, { rejectWithValue }) =>
    await tournamentsRepository.savePlayOffStage(stage).catch((error) => rejectWithValue({ error }))
);
